import * as React from "react";
import { filter, findIndex, remove } from "lodash";
import { isNullOrUndefined } from "util";
import { checkFileExtension, Component, getFiletExtension, Guid } from "../../../helpers/Utils";
import { IDispatcher } from "../../../helpers/Dispatcher";
import { File } from "../../components/File";

const style = { margin: "0 0 10px 0" };

interface Props {
	field: any;
	defaultValue: any;
	api: any;
	dispatcher: IDispatcher;
	onSave: any;
	row: any;
	file_formats: Array<string>;
	isEditable?: boolean;
}

interface FileValueItem {
	id: string;
	value: string;
	url: string;
	isLoader: boolean;
}

interface State {
	inputs: Array<FileValueItem>;
	isComment: boolean;
	comment: string;
	showHelp: boolean;
	warningDesc: string;
}

const isLoader = (inputs: Array<FileValueItem>) => {
	if (inputs !== null && inputs.length > 0) {
		for (const input of inputs) {
			if (input.isLoader) return true;
		}
	}
	return false;
};

const createEmtyInput = () => ({ id: Guid.newGuid(), value: null, url: null, isLoader: false });

export default class GridMultipleFiles extends Component<Props, State> {
	public value: any = null;

	state = {
		inputs: [createEmtyInput()],
		isComment: false,
		comment: "",
		showHelp: false,
		warningDesc: "",
	};

	componentDidMount() {
		const { defaultValue } = this.props;
		const { inputs } = this.state;
		const values = typeof defaultValue === "string" ? JSON.parse(defaultValue) : defaultValue;

		if (!isNullOrUndefined(inputs)) {
			if (!values || values.length === 0) {
				this.setState({ inputs });
				this.value = [];
			} else {
				this.setState({ inputs: [...values] });
				this.value = values;
			}
		}
	}

	onAdd = () => {
		const id = Guid.newGuid();

		this.setState(({ inputs }) => ({
			inputs: [{ id, value: null, url: null, isLoader: false }, ...inputs],
		}));
	};

	onRemove = (el: FileValueItem) => () => {
		const loaders = [...this.state.inputs];
		const idx = findIndex(loaders, (o) => o.id === el.id);
		const inputs = remove(this.state.inputs, (o: FileValueItem) => o.id !== el.id);

		if (el.url !== null) {
			loaders[idx].isLoader = true;
			this.setState({ inputs: loaders });
			this.props.api.deleteFileValue(this.props.field.field, el.value, this.toJSON(this.state, inputs), el.id, {
				success: () => {
					if (inputs.length === 0) {
						inputs.push(createEmtyInput());
					}
					this.setState({ inputs });
					this.value = inputs;

					const filterValues = inputs.filter((value) => value.value !== null);
					if (this.props?.row) {
						if (filterValues.length > 0) {
							this.props.row[this.props.field.field] = JSON.stringify(filterValues);
						} else {
							this.props.row[this.props.field.field] = null;
						}
						this.props.onSave(this.props.row);
					} else {
						this.props.onSave(filterValues);
					}
				},
			});
		} else {
			if (inputs.length === 0) {
				inputs.push(createEmtyInput());
			}
			this.setState({ inputs });
			this.value = inputs;
		}
	};

	onUpload = (id: string, event: React.ChangeEvent<HTMLInputElement>) => {
		const { file_formats } = this.props;
		const inputs = [...this.state.inputs];
		const format = file_formats || ["DOC", "DOCX", "PDF", "PNG", "JPG", "JPEG", "ZIP", "RAR"];
		const { files: _files } = event.target;
		const idx = findIndex(inputs, (o) => o.id === id);

		if (_files.length === 0) {
			return;
		}

		const filename = _files[0].name;
		const options = {
			id: this.props.field.field,
			maxSize: 0,
			format: "PDF",
			element: event.target,
		};

		if (idx > -1 && checkFileExtension(filename, format) && _files[0].size <= 10485760) {
			inputs[idx].value = filename;
			inputs[idx].url = this.props.api?.getFileUrl(id, "document");
			inputs[idx].isLoader = true;

			this.setState({ inputs });
			this.props.api.setFileValue(options, this.toJSON(this.state, inputs), id, {
				success: (response) => {
					inputs[idx].value = response.name || response.value;
					inputs[idx].url = this.props.api?.getFileUrl(id, "document");
					inputs[idx].isLoader = false;

					this.setState({ inputs, warningDesc: "" });
					this.value = inputs;

					if (this?.props?.row) {
						this.props.row[this.props?.field?.field] = this.value;
					}

					if (this.props.isEditable) {
						this.props.onSave(inputs);
					} else {
						this.props.onSave(this.props.row);
					}
				},
			});
		} else {
			let msg = "";
			if (!checkFileExtension(filename, this.props.file_formats))
				msg = `Неверный формат файла: ${getFiletExtension(filename)}`;
			else if (_files[0].size > 10485760) msg = "Размер файла превышает допустимый размер в 10 мб";

			this.setState({
				warningDesc: msg,
			});
		}
	};

	onClickHelp = () => {
		this.setState(({ showHelp }) => ({ showHelp: !showHelp }));
	};

	// TODO: Duplicate method
	// eslint-disable-next-line class-methods-use-this
	toJSON = (state: State, inputs: Array<any>) => {
		const inputsData = filter(inputs, (obj) => obj.url !== null).map((obj) => ({
			id: obj.id,
			url: obj.url,
			value: obj.value,
		}));

		if (state.isComment) {
			return { isComment: state.isComment, comment: state.comment, inputs: [] };
		}
		return inputsData.length > 0
			? JSON.stringify({
					isComment: state.isComment,
					comment: state.comment,
					inputs: inputsData,
			  })
			: "";
	};

	createInputFile = (isMain: boolean, el: FileValueItem, showButtons, multiple: boolean) => {
		const disabled = false;
		const options = { ...this.props, ...el };

		return (
			<div className="input-group" style={style} key={`File.${el.id}`}>
				<File {...options} onChange={this.onUpload} />
				<span className="input-group-btn">
					<button type="button" onClick={this.onClickHelp} className="btn btn-default btn-add">
						<span className="glyphicon glyphicon-question-sign" />
					</button>
					{showButtons && isMain && multiple && (
						<button
							disabled={disabled}
							title="Добавить еще"
							type="button"
							className="btn btn-default btn-add"
							onClick={this.onAdd}
						>
							<span className="glyphicon glyphicon-plus-sign" />
						</button>
					)}
					{((showButtons && isMain && el.value !== null) || (showButtons && !isMain)) && (
						<button disabled={disabled} type="button" className="btn btn-danger btn-remove" onClick={this.onRemove(el)}>
							Удалить
						</button>
					)}
				</span>
			</div>
		);
	};

	render() {
		const {
			field: { multiple },
			file_formats,
		} = this.props;
		const { inputs, isComment, showHelp, warningDesc } = this.state;
		const isEnableComment = false;
		const isShowButtons = !isLoader(inputs);

		return !isComment || !isEnableComment ? (
			<div className="notnull">
				{inputs.map((item: FileValueItem, idx: number) =>
					this.createInputFile(idx === inputs.length - 1, item, isShowButtons, multiple)
				)}
				{showHelp && (
					<div className="alert alert-warning" role="alert">
						Допустимые форматы файлов для загрузки: {typeof file_formats !== "undefined" ? file_formats.join(",") : ""}.
						<br />
						Максимальный размер файла не должен превышать 10Мб
					</div>
				)}
				{warningDesc && (
					<div className="alert alert-warning" role="alert">
						{warningDesc}
					</div>
				)}
			</div>
		) : (
			<div className="null" />
		);
	}
}

export function createGridMultiFiles(field, defaultValue, api, dispatcher, onSave, row) {
	return (
		<GridMultipleFiles
			field={field}
			defaultValue={defaultValue}
			api={api}
			dispatcher={dispatcher}
			onSave={onSave}
			row={row}
			file_formats={[]}
		/>
	);
}
